module.exports = __webpack_public_path__ + "static/media/GTO-HEADER.09a98506.png";